import React from 'react';

import { snowflakeStyles } from './styles';

const SnowAnimation = ({ count = 30 }: { count?: number }) => {
	return (
		<>
			{[...Array(count)].map((_, index) => (
				<div className={snowflakeStyles} key={index} aria-hidden='true'>
					❅
				</div>
			))}
		</>
	);
};

export default SnowAnimation;
